import { render, staticRenderFns } from "./ProtocoloDetalhe.vue?vue&type=template&id=213d9ae0&scoped=true"
import script from "./ProtocoloDetalhe.vue?vue&type=script&lang=js"
export * from "./ProtocoloDetalhe.vue?vue&type=script&lang=js"
import style0 from "./ProtocoloDetalhe.vue?vue&type=style&index=0&id=213d9ae0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213d9ae0",
  null
  
)

export default component.exports